/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Update pair request
 */
export interface UpdatePairRequest {
  pairId: number;
  isStableCoinPair: boolean;
  supportHouse: boolean;
  priceProtection: boolean;
  priceScale: number;
  priceScaleView: number;
  qtyScale: number;
}
